import React, { useState, useEffect } from "react";
import "../Slider/Slider.css";
import { Link } from "react-router-dom";
const slides = [
  {
    image: "s1.webp",
    heading: "Welcome to Green Haven Nursery",
    description:
      "Discover a wide variety of plants and greenery to bring life to your spaces. Your journey to a lush and vibrant garden starts here.",
  },
  {
    image: "s2.webp",
    heading: "Nurturing Nature with Care",
    description:
      "Explore our collection of indoor, outdoor, and exotic plants, along with expert guidance to help them thrive.",
  },
  {
    image: "s3.webp",
    heading: "Sustainable Gardening Solutions",
    description:
      "From organic fertilizers to eco-friendly pots, we offer everything you need to cultivate a sustainable green environment.",
  },
];

const Slider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slideCount = slides.length;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev === slideCount - 1 ? 0 : prev + 1));
    }, 4000);

    return () => clearInterval(interval);
  }, [slideCount]);

  return (
    <div className="slider-container">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`slide ${index === currentSlide ? "active" : ""}`}
          style={{ backgroundImage: `url(${slide.image})` }}
        >
          {index === currentSlide && (
            <div className="overlay">
              <h1>{slide.heading}</h1>
              <p>{slide.description}</p>
              <Link to="/contact">
                <button className="btn-get-started">Get Started</button>
              </Link>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Slider;
